const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the google redirect component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('googleRedirect', ['Application', 'Authorization', 'GoogleGeneral', function (Application, Authorization, GoogleGeneral) {
  return {
    restrict: 'E',
    replace: true,
    scope: {},
    template: require('../../templates/directives/google-redirect.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      self.user = Authorization.getAuthToken().user;
      var params = Application.navigation.getUrlParameters();
      var options = Application.storage.get('gcal_redirect');

      options.query = options.query || {};
      if (params.code && params.code !== 'null') {
        GoogleGeneral.submitCode({user: self.user._id}, {code: params.code}).$promise
        .then(function(result) {
          Application.navigation.goTo(options.path, options.query);
          return;
        }).catch(function(error) {
          Application.messaging.addMessage({type: 'error', duration: 5, text: 'Unable to integrate with Google at this time.'});
          Application.navigation.goTo(options.path, options.query);
          return;
        });
      }

      if (params.error && params.error !== 'null') {
        if (params.error === 'access_denied') {
          Application.messaging.addMessage({type: 'error', duration: 5, text: 'You have denied access to your Google Calendar.'});
          Application.navigation.goTo(options.path, options.query);
          return;
        }
        Application.messaging.addMessage({type: 'error', duration: 5, text: 'Unable to integrate with Google at this time.'});
        Application.navigation.goTo(options.path, options.query);
        return;
      }

    }],
    controllerAs: 'googleRedirect'
  };
}]);